import {
  Box,
  Button,
  Menu,
  MenuItem,
  ButtonGroup,
  Card,
  Checkbox,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@mui/material';
import { _axios } from 'src/plugins/axios';
import React, { useEffect, useState,useRef } from 'react';
import { Search as SearchIcon, Download as ExportIcon } from 'react-feather';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PerfectScrollbar from 'react-perfect-scrollbar';
import moment from 'moment';
import CustomButton from 'src/components/common/customButton';

const AhcMisResults = ({
  totalCount,
  onPaginationChange,
  exportFile,
  displayEmployees,
  allEmployees,
  activeBookings,
  activeTable,
  DownloadReports,  
  ...props
}) => {
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);
  const [exportType, setExportType] = useState('xlsx');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [employees, setEmployees] = useState(
    displayEmployees.length > 0 &&
      displayEmployees.slice(page * limit, (page + 1) * limit)
  );
  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    if (activeTable == 1) {
      onPaginationChange('limit', event.target.value, activeTable);
    }
    if (activeTable == 0) {
      onPaginationChange('limit', event.target.value, activeTable);
    }
  };

  const fileList = [
    {
      id: 'CSV',
      title: 'csv'
    },
    {
      id: 'XLSX',
      title: 'xlsx'
    }
  ];

  const handleClose = (item) => {
    setAnchorEl(null);
    if (item) {
      setExportType(item.title);
    }
  };

  const setActiveTable = (value) => {
    setLimit(5);
    setPage(0);
    props.setActiveTable(value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (activeTable == 1) {
      onPaginationChange('page', newPage, activeTable);
    }
    if (activeTable == 0) {
      onPaginationChange('page', newPage, activeTable);
    }
  };

  const openPdfInNewTab = (reportUrl, customName) => {
    _axios.get(reportUrl, { responseType: 'blob' })
      .then((response) => {
        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: 'application/pdf' });
  
        const blobUrl = URL.createObjectURL(blob);
        
        const downloadLink = document.createElement('a');
        downloadLink.href = blobUrl;
        downloadLink.download = customName;
        downloadLink.click();
        URL.revokeObjectURL(blobUrl);
      })
      .catch((err) => {
        console.error('Error downloading PDF:', err);
      });
  };
  
  return (
    <>
      <Grid container>
        <Grid xs={12} justifyContent="space-between" container item>
          <Grid
            item
            container
            sx={{
              borderRadius: 3,
              border: '1px solid #1778f2',
              width: '152px',
              height: '40px'
            }}
          >
            <CustomButton
              loading={
                props.loading.activeBookings || props.loading.allEmployees
              }
              onClick={() => setActiveTable(0)}
              fontSize={12}
              shadow="false"
              active={activeTable == 0}
              title="MIS Data"
              sx={{
                borderRadius: 2,
                height: '100%',
                width: '150px'
              }}
            />
          </Grid>
          <Grid
            item
            container
            sx={{
              width: '180px'
            }}
          >
            <ButtonGroup
              variant="text"
              disabled={false}
              sx={{ boxShadow: '0 0 4px rgba(0,0,0,0.20)', borderRadius: 15 }}
            >
              <Button
                sx={{ px: 2 }}
                onClick={() => exportFile(exportType)}
                startIcon={<ExportIcon size="18" />}
              >
                Export
              </Button>
              <Button
                onClick={(e) => setAnchorEl(e.currentTarget)}
                endIcon={<ArrowDropDownIcon />}
              >
                {exportType}
              </Button>
            </ButtonGroup>
          </Grid>
          <Menu
            id="export-menu"
            open={open}
            anchorEl={anchorEl}
            onClose={() => handleClose()}
            MenuListProps={{
              'aria-labelledby': 'exporttypeMenu'
            }}
          >
            {fileList.map((menu) => (
              <MenuItem key={menu.id} onClick={() => handleClose(menu)}>
                {menu.title}
              </MenuItem>
            ))}
          </Menu>
        </Grid>
        <Grid xs item>
          <Card
            elevation={0}
            sx={{
              mt: 2
            }}
          >
            <PerfectScrollbar>
              <Box sx={{ minWidth: activeTable ? 1800 : 1000 }}>
                <TableContainer sx={{ maxHeight: 500 }}>
                  <Table
                    stickyHeader
                    aria-label="Employee list"
                    id="employee-list"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox">
                          <Checkbox
                            sx={{
                              '& .MuiSvgIcon-root': {
                                fontSize: 18
                              }
                            }}
                            color="primary"
                          />
                        </TableCell>
                        <TableCell>PatientName</TableCell>
                        <TableCell>EmployeeId</TableCell>
                        <TableCell>Gender</TableCell>
                        <TableCell>Age</TableCell>
                        <TableCell>Relation</TableCell>
                        <TableCell>Package</TableCell>
                        <TableCell>AppointmentDate</TableCell>
                        <TableCell>AppointmentStatus</TableCell>
                        <TableCell>Provider</TableCell>
                        <TableCell>Location</TableCell>
                        <TableCell>City</TableCell>
                        <TableCell>State</TableCell>
                        <TableCell>VisitType</TableCell>
                        <TableCell>CurrentStatusName</TableCell>
                        <TableCell>MobileNumber</TableCell>
                        <TableCell>EmailId</TableCell>
                        <TableCell>CorporateName</TableCell>
                        <TableCell>DCName</TableCell>
                        <TableCell>DCLocation</TableCell>
                        <TableCell>TestName</TableCell>
                        <TableCell>AppointmentConfirmationDate</TableCell>
                        <TableCell>AppointmentConfirmationTAT</TableCell>
                        <TableCell>AppointmentRescheduleDate1</TableCell>
                        <TableCell>AppointmentRescheduleDate2</TableCell>
                        <TableCell>AppointmentRescheduleDate3</TableCell>
                        {DownloadReports && (
                          <TableCell>Download Reports</TableCell>
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(displayEmployees.length > 0
                        ? displayEmployees
                        : displayEmployees.slice(
                            page * limit,
                            (page + 1) * limit
                          )
                      ).map((employee, idx) => (
                        <TableRow hover key={idx}>
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              sx={{
                                '& .MuiSvgIcon-root': {
                                  fontSize: 18
                                }
                              }}
                              value="true"
                            />
                          </TableCell>
                          <TableCell>{employee.PatientName}</TableCell>
                          <TableCell>{employee.EmployeeId}</TableCell>
                          <TableCell>{employee.Gender} </TableCell>
                          <TableCell>{employee.Age}</TableCell>
                          <TableCell>{employee.Relation}</TableCell>
                          <TableCell>{employee.Package}</TableCell>
                          <TableCell>
                            {moment(employee.AppointmentDate).format(
                              'DD-MM-YYYY'
                            )}
                          </TableCell>
                          <TableCell>{employee.AppointmentStatus}</TableCell>
                          <TableCell>{employee.Provider}</TableCell>
                          <TableCell>{employee.Location}</TableCell>
                          <TableCell>{employee.City}</TableCell>
                          <TableCell>{employee.State}</TableCell>
                          <TableCell>{employee.VisitType}</TableCell>
                          <TableCell>{employee.CurrentStatusName}</TableCell>
                          <TableCell>{employee.MobileNumber}</TableCell>
                          <TableCell>{employee.EmailId}</TableCell>
                          <TableCell>{employee.CorporateName}</TableCell>
                          <TableCell>{employee.DCName}</TableCell>
                          <TableCell>{employee.DCLocation}</TableCell>
                          <TableCell>{employee.TestName}</TableCell>
                          <TableCell>
                            {employee.AppointmentConfirmationDate}
                          </TableCell>
                          <TableCell>
                            {employee.AppointmentConfirmationTAT}
                          </TableCell>
                          <TableCell>
                            {employee.AppointmentRescheduleDate1}
                          </TableCell>
                          <TableCell>
                            {employee.AppointmentRescheduleDate2}
                          </TableCell>
                          <TableCell>
                            {employee.AppointmentRescheduleDate3}
                          </TableCell>
                          {DownloadReports && employee.ReportUrls && (
                            <TableCell>
                              <ul style={{ listStyleType: 'none', padding: 0 }}>
                                {employee.ReportUrls.map((reportUrl, index) => (
                                  <li key={index}>
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        openPdfInNewTab(
                                          reportUrl,
                                          `${employee.EmployeeId}_${employee.PatientName}_${index + 1}.pdf`
                                        );
                                      }}
                                    >
                                      Report {index + 1}
                                    </a>
                                   
                                  </li>
                                ))}
                              </ul>
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </PerfectScrollbar>
            <TablePagination
              component="div"
              count={totalCount}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleLimitChange}
              page={page}
              rowsPerPage={limit}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default AhcMisResults;
